<script lang="ts" setup>
import type { Analytics } from '@/store/analytics/analytics.types'

import type { MenuLink } from '@/types/common'

import LazyTheFooter from '@/components/Footer/LazyTheFooter.vue'
import TheHeader from '@/components/Header/TheHeader.vue'
import TheSidebar from '@/components/Sidebar/TheSidebar.vue'

const menuLinks = [
  {
    title: 'Франшиза',
    url: 'https://farfor.ru/partner/',
  },
  {
    title: 'Работа в FARFOR',
    url: 'https://farfor.ru/jobs/',
  },
  {
    title: 'Тайный покупатель',
    url: 'https://farfor.ru/control/',
  },
] as MenuLink[]

const { isMobileOrTablet } = useDevice()

const isShowNavMenu = ref(false)

const { data } = await useNuxtApi<Analytics>('/api/analytics')

const onShowSidebar = () => {
  isShowNavMenu.value = !isShowNavMenu.value
}

const yandex = data.value?.yandex
const google = data.value?.google

useHead({
  meta: [
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1.0, maximum-scale=5',
    },
    {
      name: 'yandex-verification',
      content: yandex?.verification,
    },
    {
      name: 'google-site-verification',
      content: google?.verification,
    },
  ],
})
</script>

<template>
  <div class="layout">
    <NuxtLoadingIndicator color="#fe5000" />

    <div class="layout__container">
      <the-header
        :is-show-nav-menu="isShowNavMenu"
        :menu-links="menuLinks"
        @on-show-sidebar="onShowSidebar"
      />

      <div class="page-wrapper">
        <slot />
      </div>

      <the-navigation-drawer
        v-if="isMobileOrTablet"
        v-model="isShowNavMenu"
        top="60"
      >
        <the-sidebar :menu-links="menuLinks" />
      </the-navigation-drawer>
    </div>

    <div class="layout__footer">
      <div class="layout__footer-wrapper">
        <lazy-the-footer />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@mixin widthLayout {
  width: 100%;
  margin: 0 auto;

  @include media($bp-desktop-mini) {
    width: 1000px;
  }

  @include media($bp-desktop) {
    width: 1200px;
  }
}

.layout {
  color: var(--ui-color-white);
  background-color: $background-dark;

  :deep(.app-navigation-drawer) {
    background-color: $background-dark;
  }

  .layout__container {
    position: relative;
    padding-top: 60px; // высота гамбургера

    @include widthLayout;

    @include media($bp-tablet) {
      padding-top: 121px; // высота лого
    }

    @include media($bp-desktop-mini) {
      padding-top: 90px;
    }
  }

  &__footer {
    background-color: black;

    &-wrapper {
      @include widthLayout;
    }
  }
}

.page-wrapper {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 60px); // -header

  @include media($bp-tablet) {
    min-height: calc(100vh - 121px); // -header
  }

  @include media($bp-desktop-mini) {
    min-height: calc(100vh - 349px); // -footer и -header
  }
}
</style>
